import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eventIcon from "../../assets/svg/calendar_1.svg";
import EC from "../../assets/config/enum-codes.json";
import feedbackIcon from "../../assets/svg/feedback.svg";
import surveyIcon from "../../assets/svg/survey.svg";
import publicAssessmentIcon from "../../assets/png/publicAssessmentThumbnail.png";
import { useGetAssetsFromStrapiMutation } from "@lxp-app/pages/eventCreationWorkflowV2/slices/uploadGetApi";
function ResultListItem({
  item,
  setOpen
}: {
  item: any;
  setOpen: (val: boolean) => void;
}): React.ReactNode {
  const navigate = useNavigate();
  const [getAssetsFromStrapi, { isLoading }] = useGetAssetsFromStrapiMutation();
  const [imgSrc, setImgSrc] = useState("");

  function getContentType(type: string) {
    switch (type) {
      case "COURSE":
        return "LinkedIn Course";
      case "course":
        return "Course";
      case "pdf":
        return "Article";
      case "event":
        return "Event";
      case "weblink":
        return "Web Content";
      case "cmi5":
        return "E-Learning";
      case "video":
        return "Video";
      case "learningpath":
        if (item?.sourcetype?.toLowerCase() === "external") {
          return "LinkedIn Learning Path";
        } else if (item?.sourcetype?.toLowerCase() === "internal") {
          return "Learning Path";
        }
        break;
      case "episode":
        return "Episode";
      case "podcast":
        return "Podcast";
      case "tech_document":
        return "Tech Document";
      case "tech_talk":
        return "Tech Talk";
      case "blog":
        return "Blog";
      case "innovation":
        return "Innovation";
      case "assesment":
      case "quiz_assessment":
      case "assessment_schedule":
        return "Assessment";
      case "quiz":
        return "Quiz";
      case "cafe":
        return "Cafe";
    }
  }

  function getSkeleton() {
    return (
      <div className="h-16 aspect-video object-cover bg-secondary/5 animate-pulse"></div>
    );
  }

  useEffect(() => {
    const assetId = item?.branding?.thumbnail[0];

    if (typeof assetId == "number")
      getAssetsFromStrapi([assetId])
        .then((res: any) => {
          setImgSrc(
            res.data.data[0]?.formats?.thumbnail?.url ?? res.data.data[0].url
          );
        })
        .catch((err: any) => {
          console.log(err);
        });
    else setImgSrc(assetId);
  }, []);

  return (
    <button
      type="button"
      key={item.id}
      className="relative bg-bkg flex w-full items-center p-6 mt-6 rounded-xl cursor-pointer group gap-x-8 text-left hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-dark-widget"
      onClick={() => {
        setOpen(false);
        const routes: Record<string, string> = {
          event: `/event/event-details/${item.id}`,
          course: `/content-viewer/course-internal/${item.id}`,
          episode: `/content-viewer/podcast-episode/${item.id}`,
          podcast: `/content-viewer/podcast/${item.id}`,
          blog: `/content-viewer/blog/${item.id}`,
          innovation: `/content-viewer/innovation/${item.id}`,
          tech_talk: `/content-viewer/tech_talk/${item.id}`,
          tech_document: `/content-viewer/tech_document/${item.id}`,
          cafe: `/cafe-lounge/view/${item.id}?ref=/search`,
          assessment_schedule: `content-viewer/assessment/${item.id}`
        };

        const artifactTypes = [
          "pdf",
          "video",
          "cmi5",
          "COURSE",
          "learningpath",
          "weblink",
          "assessment_schedule"
        ];

        if (
          item.eventtype === "eventType3" ||
          item.eventtype === "eventType4" ||
          item.eventtype === "eventType5"
        ) {
          navigate(routes["cafe"]);
        } else if (routes[item.artifacttype]) {
          navigate(routes[item.artifacttype]);
        } else if (artifactTypes.includes(item.artifacttype)) {
          navigate(
            `/content-viewer/${EC.ArtifactTypesFE[item.artifacttype as keyof typeof EC.ArtifactTypesFE]}/${item.id}`
          );
        }
      }}
    >
      <div className="flex items-center justify-center flex-none mt-1 rounded-lg bg-secondary/5">
        {(() => {
          const artifactType =
            typeof item?.artifacttype === "string"
              ? item.artifacttype.trim()
              : "";

          if (artifactType === "COURSE") {
            return (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={item?.brandingurls?.thumbnail[0]}
                alt="linkedIn_Thumbnail"
              />
            );
          } else if (artifactType === "course") {
            return isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="course_icon"
              />
            );
          }

          const normalizedType = artifactType.replace(/\s+/g, "").toLowerCase();
          return normalizedType === "pdf" ? (
            isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="pdf_icon"
              />
            )
          ) : normalizedType === "video" ? (
            isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="video_icon"
              />
            )
          ) : ["cmi5", "e-learning"].includes(normalizedType) ? (
            isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="e_learning_icon"
              />
            )
          ) : normalizedType === "learningpath" &&
            item?.sourcetype?.toLowerCase() === "external" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="LP_icon_external"
            />
          ) : normalizedType === "learningpath" &&
            item?.sourcetype?.toLowerCase() === "internal" ? (
            isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="LP_icon_internal"
              />
            )
          ) : normalizedType === "weblink" ? (
            isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="web_link_icon"
              />
            )
          ) : normalizedType === "podcast" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="podcast_icon"
            />
          ) : normalizedType === "episode" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="episode_icon"
            />
          ) : normalizedType === "feedback" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="w-10 h-10"
              src={feedbackIcon}
              alt="feedback_icon"
            />
          ) : normalizedType === "survey" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="w-10 h-10"
              src={surveyIcon}
              alt="survey_icon"
            />
          ) : normalizedType === "event" ? (
            isLoading ? (
              getSkeleton()
            ) : (
              <img
                onContextMenu={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
                className="h-16 aspect-video object-cover border rounded-lg"
                src={imgSrc}
                alt="event_icon"
              />
            )
          ) : normalizedType === "tech_document" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="tech_document_icon"
            />
          ) : normalizedType === "tech_talk" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="tech_talk_icon"
            />
          ) : normalizedType === "blog" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="blog_icon"
            />
          ) : normalizedType === "innovation" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={item?.brandingurls?.thumbnail[0]}
              alt="innovation_icon"
            />
          ) : normalizedType === "assessment_schedule" ? (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="h-16 aspect-video object-cover border rounded-lg"
              src={publicAssessmentIcon}
              alt="public_assessment_icon"
            />
          ) : (
            <img
              onContextMenu={(e) => e.preventDefault()}
              style={{ userSelect: "none" }}
              className="w-8 h-8"
              src={eventIcon}
              alt="default_icon"
            />
          );
        })()}
      </div>

      <div className="flex flex-col gap-1">
        <div className="text-primary font-medium">
          {getContentType(
            item.eventtype === "eventType3" ||
              item.eventtype === "eventType4" ||
              item.eventtype === "eventType5"
              ? "cafe"
              : item.artifacttype
          )}
        </div>
        <div className="font-medium">{item.title}</div>
      </div>
    </button>
  );
}

export default ResultListItem;
